<template>
  <v-card class="homepage-v-card">
  <v-card-actions>
    <AddButton
      :handle-click="() => (displayEventForm = true)"
      v-if="!displayEventForm"
    />

    <v-fab-transition>
      <v-btn
        fab
        absolute
        right
        v-if="events"
        @click="showCalendar = !showCalendar"
        ><v-icon>mdi-calendar</v-icon></v-btn
      >
    </v-fab-transition>
  </v-card-actions>
  
<v-card-text class="glass-element">
    <transition name="fade">
      <EventForm
        :event="currentEvent"
        :handle-close="() => (displayEventForm = false)"
        v-if="displayEventForm"
      />
    </transition>
    <EventItemSearch
      v-if="eventItems"
      :eventItems="eventItems"
      :events="events"
    />
    <Calendar v-show="showCalendar" />
    <EventList :events="events" />
    </v-card-text>

  </v-card>
</template>

<script>
import EventItemSearch from "@/components/atoms/EventItemSearch";
import EventList from "@/components/molecules/EventList";
import AddButton from "@/components/atoms/AddButton";
import EventForm from "@/components/molecules/EventForm";
import Calendar from "@/components/atoms/Calendar";
import { mapState } from "vuex";
import router from "@/router/index";

export default {
  components: { EventList, AddButton, EventForm, Calendar, EventItemSearch },
  data() {
    return {
      showCalendar: false,
      displayEventForm: false,
    };
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("getEvents");
      await this.$store.dispatch("getNotifications");
      await this.$store.dispatch("getInvitations");
      await this.$store.dispatch("getOwnProfile");
      await this.$store.dispatch("getCompulsoryDocuments").then(() => {
        let tempCompDocs = this.compulsoryDocuments.map((d) => d.id);
        let acceptedDocs = this.ownProfile.accepted_documents.map((d) => d.id);
        if (acceptedDocs == null) {
          // Redirect to the document acceptance page.
          router.push("/my_documents");
        }
        for (const doc of tempCompDocs) {
          if (!acceptedDocs.includes(doc)) {
            // Redirect to the document acceptance page.
            router.push("/my_documents");
          }
        }
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  computed: mapState({
    eventItems: (state) => state.events?.eventItems.filter(e => e.item_status == 'PU'),
    count: (state) => state.events?.events?.results.length,
    events: (state) => state.events?.events?.results,
    compulsoryDocuments: (state) => state.documents.compulsoryDocuments,
    ownProfile: (state) => state.profiles.ownProfile,
  }),
};
</script>
<style scoped>
.homepage-v-card{
      background: transparent;
    border: none;
    box-shadow: none;
}
</style>